module.exports = __webpack_public_path__ + "img/CI250.602511d2.png";